import loadable from '@loadable/component';

export const CmsAccordionBlockLoadable = loadable(
  () => import('./CmsAccordionBlock'),
  { resolveComponent: (module) => module.CmsAccordionBlock },
);
